import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Table, Pagination, Offcanvas, Button } from 'react-bootstrap'
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import { formatDateDMY, formateDatemdy } from "../../utils/Helper"
import { ToastContainer, toast } from "react-toastify";
import DeleteModal from "../../components/common/DeleteModel";
import RoleFilter from "./RoleFilter";
import { capitalizeFirstLetter } from "../../utils/Helper"


const RoleList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [roleList, setroleList] = useState([]);
  const [name, setName] = useState("");
  const [show, setShow] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showDt, setShowDt] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const statusRef = useRef("Select Status");
  const limit = 10;
  const offset = (currentPage - 1) * limit;
  const paginatedData = roleList.slice(offset, offset + limit);
  const navigate = useNavigate();
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };

  useEffect(() => {
    fetchData(currentPage, filters);
  }, [currentPage, filters]);


  const fetchData = async (page = 1, filters) => {
    const params = {
      ...filters,
      offset: (page - 1) * limit,
      limit: limit,
      system_role: 0
    };

    const queryString = Object.entries(params)
      .filter(
        ([_, value]) =>
          value !== "" && value !== undefined && value !== null
      )
      .map(([key, value]) => `${key}=${value}`)
      .join("&");


    const encodedStatus =
      statusRef.current === "Select Status" ? "" : statusRef.current;
    try {
      const response = await APIServices.get(
        `/admin/role_list?${queryString}`,
        headers
      );
      if (response?.status === 200) {
        const roleList = response?.data?.data?.list || [];
        setroleList(roleList);
        setCount(response?.data?.count)
        setTotalCount(response?.data?.data?.list?.length || 0);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setroleList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setroleList([]);
      setTotalCount(0);
    }
  };



  const handleStatusChange = async (faq) => {
    const newStatus = faq.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { id: faq.id, status: newStatus };
      const res = await APIServices.post(
        `/admin/role_status_update`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        const updatedFaqs = roleList.map((item) =>
          item.id === faq.id ? { ...item, status: newStatus } : item
        );
        setroleList(updatedFaqs);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  const handleDeleteFaq = async () => {
    try {
      if (selectedUser !== null) {
        const payload = { id: selectedUser };
        const res = await APIServices.post(
          `/admin/delete_role`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          const updatedFaqs = roleList.filter((faq) => faq.id !== selectedUser);
          setroleList(updatedFaqs);

          setSelectedUser(null);
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
      setShowDt(false);
    } catch (error) {
      console.error("Error deleting FAQ:", error);
    }
  };

  return (
    <>
      <div className="momList_inner todo_list_inner subAdmin_list_inner ">
        <div className="mom_header d-flex align-items-center justify-content-between mb-3">
          <h1 className="font_blue_18 font-600">{`Role List (${count})`}</h1>

          <ul className="d-flex align-items-center mom_filter">
            <li
              className="d-flex align-items-center cursor-pointer"
              onClick={() => setShowFilter(true)}
            >
              Filter By{" "}
              <img
                src="/images/Sort.svg"
                className="img-fluid ms-2"
                alt="Sort"
              />
            </li>

            <li>
              <button
                className="btn red_button d-flex align-items-center"
                onClick={() => navigate("/admin/add-role")}
              >
                <FaPlus className="me-1" />
                Add Role
              </button>
            </li>
          </ul>
        </div>

        <div className="todoList_table">
          <div className="table-responsive">
            <Table>
              <thead className="table-dark">
                <tr>
                  <th>Sr.No</th>
                  <th>Role</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Manage</th>
                </tr>
              </thead>
              <tbody>
                {roleList.map((user, index) => (
                  <tr key={user.id}>
                    <td>{(currentPage - 1) * limit + index + 1}</td>

                    <td>{capitalizeFirstLetter(user.name)}</td>
                    <td>{formateDatemdy(user.created_at)}</td>

                    <td>
                      <Form className="Switch_toggle">
                        <input
                          type="checkbox"
                          checked={user.status === "Active"}
                          onClick={() => handleStatusChange(user)}
                          id={`switch-${user.id}`}
                        />
                        <label
                          for="switch"
                          className="position-relative"
                          htmlFor={`switch-${user.id}`}
                        >
                          Toggle
                        </label>
                      </Form>
                    </td>

                    <td>
                      <ul className="d-flex align-items-center list-unstyled mb-0">
                        <li className="me-2">
                          <button
                            className="btn btn-sm btn-outline-success py-1"
                            onClick={() => navigate(`/admin/add-role/${user.id}`)}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              minWidth: '32px'
                            }}
                          >
                            <FaEdit />
                          </button>
                        </li>
                        <li>
                          <button
                            className="btn btn-sm btn-outline-danger py-1"
                            onClick={() => {
                              setSelectedUser(user.id);
                              setShowDt(true);
                            }}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              minWidth: '32px'
                            }}
                          >
                            <FaTrash />
                          </button>
                        </li>
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      {showFilter && (
        <RoleFilter
          appliedFilters={filters}
          show={showFilter}
          onHide={() => setShowFilter(false)}
          onApplyFilter={(filterData) => {
            setFilters(filterData);
            setShowFilter(false);
          }}
          onClear={() => {
            setFilters({});
            setShowFilter(false);
          }}
        />
      )}
      <ToastContainer />
      <DeleteModal
        showdt={showDt}
        handleCloseDt={() => setShowDt(false)}
        handledelete={handleDeleteFaq}
      />
    </>
  );
}

export default RoleList